export default __webpack_public_path__ + "images/dc853ffbde8463dc72c9fd6f50ff72c3.png";